import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CarePlanPanelComponent } from '@brightnav/care-plan';

@Component({
  selector: 'bn-care-plan-tab',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CarePlanPanelComponent],
  template: `
    <div class="bn-care-plan-tab flex flex-col gap-4">
      <bn-care-plan-panel />
    </div>
  `,
})
export class CarePlanTabComponent {}
